import { Button, StyledForm, Text } from '@/components/common';
import { FormMarginDense, FormWrapper } from '@/components/form';
import CheckboxTerm from '@/components/page/Register/CheckboxTerm';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { UserType } from '@/utils/constant';
import { Box, styled } from '@mui/material';
import { Formik } from 'formik';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../hook/useUser';
import { Icon, Paragraph } from './styles';
import { sendConsentKyc3 } from '@/api/user';
import { ModalRenderer } from '@/utils/modalUtils';
import SomethingWentWrongModal from '@/components/modal/SomethingWentWrongModal';

export const Divider = styled('div')({
  margin: '32px 0px',
  height: '1px',
  backgroundColor: '#191919',
  width: '100%',
});

const InsuranceDeclarationPage: React.FC<any> = () => {
  const navigate = useNavigate();
  const userType = useAppSelector((state: any) => state.user.userType);
  const dispatch = useAppDispatch();
  const userId = useAppSelector((state: any) => state.auth.userId);
  const [reloadUser] = useUser(userId);
  const isAddPaymentMethodForCP = useAppSelector((state: any) => state.user.isAddPaymentMethod);
  const isJustCheckedConsent = sessionStorage.getItem('consent_checked')?.includes(userId);
  const [checkAgree, setCheckAgree] = React.useState(isJustCheckedConsent ? true : false);

  useEffect(() => {
    dispatch({ type: 'HIDE_LOADING' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmit = async () => {
    dispatch({ type: 'SHOW_LOADING' });
    if (!isJustCheckedConsent) {
      try {
        await sendConsentKyc3(userId);
      } catch (error) {
        dispatch({ type: 'HIDE_LOADING' });
        ModalRenderer.open({
          component: SomethingWentWrongModal,
          theme: 'white',
          inMobile: 'bottom',
        });
        return;
      }
    }
    if (userType === UserType.RENTAL_CARS || (userType === UserType.CONCIERGE_PORTAL && isAddPaymentMethodForCP)) {
      await reloadUser();
      navigate('/payment-method');
      dispatch({ type: 'HIDE_LOADING' });
      return;
    } else {
      const kycId = localStorage.getItem('kyc_id');
      window.location.href = `/kyc/${kycId}/result`;
      return;
    }
    // await handleVerifyAdditionalDriver();
  };
  const { t } = useTranslation();
  const content =
    userType === UserType.ADDITIONAL_DRIVER
      ? t('INSURANCE_DECLARATION_MODAL_AD').split('\n')
      : t('INSURANCE_DECLARATION_MODAL').split('\n');
  const max = content.length;

  return (
    <FormWrapper>
      <Text color="darkPrimary" variant="title">
        {t('INSURANCE_DECLARATION')}
      </Text>
      <Text color="darkSecondary" variant="content">
        {content[0]}
      </Text>
      {content.map((ele, index) => {
        if (index > 0 && index < max - 2) {
          let src = ele.split('|')[0];
          let txt = ele.split('|')[1];
          return (
            <Box key={index} sx={{ mt: { xxl: index === 1 ? 6 : 3, xxs: index === 1 ? 5 : 3 } }}>
              <Paragraph>
                <Icon src={src} width="20px" height="20px" alt="" />
                <Text color="darkSecondary" variant="content">
                  {txt}
                </Text>
              </Paragraph>
            </Box>
          );
        }
        return null;
      })}

      <FormMarginDense value="10">
        <Text color="secondary2" variant="content" style={{ paddingLeft: '36px' }}>
          {content[max - 2]}
        </Text>
      </FormMarginDense>

      <Divider />

      <Formik initialValues={{}} onSubmit={onSubmit}>
        {(props) => (
          <StyledForm>
            <div>
              {isJustCheckedConsent ? null : (
                <CheckboxTerm
                  onClick={() => {
                    setCheckAgree((prev) => !prev);
                  }}
                  testId="test_checkbox_terms"
                  checked={checkAgree}
                  text={t('AGREE_TO_THESE_TERMS')}
                />
              )}
              <FormMarginDense>
                <Button
                  disabled={!isJustCheckedConsent && !checkAgree}
                  fullWidth
                  variant="contained"
                  color="white"
                  type="submit"
                >
                  {t('CONTINUE')}
                </Button>
              </FormMarginDense>
            </div>
          </StyledForm>
        )}
      </Formik>
    </FormWrapper>
  );
};

export default InsuranceDeclarationPage;
